/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useDeleteWriteOffReason
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for delete write off reason
 *
 */
interface IProps {
	model: EntitySettings.IWriteOffReasonDeleteRequest;
}
const useDeleteWriteOffReason = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ model }) => {
			const { data } = await api.WriteOffReasonApi.deleteWriteOffReason(model);
			return data;
		},
		onSuccess: (data) => {
			// is deleted key will be true if data is deleted completely
			AppEvents.publishApiSuccess(data?.isDeleted ? '' : "Write-Off Reason has been marked as 'inactive'");
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.writeOffReasons] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteWriteOffReason;
